export default __webpack_public_path__ + "static/media/Group3398-tata-neu.d6be1fbd.png";